export default {
  methods: {
    convertCamelCaseToTitleCase(text) {
      const result = text.replace(/([A-Z])/g, ' $1');
      return result.charAt(0).toUpperCase() + result.slice(1);
    },
    convertStringToTitle(string) {
      return string.replaceAll('-', ' ').replaceAll('_', '-');
    },
    capitalize(string) {
      return this.capitalizeFirstLetter(string.toLowerCase());
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
    filterString(string) {
      return string.trim().replace(/[^\S \n]+/g, '');
    },
    isEqualString(string1, string2) {
      return this.filterString(string1) === this.filterString(string2);
    },
  },
};
